import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const VideoIcon = (p: IconProps) => <Icon {...p}><path d="m22 8-6 4 6 4V8Z" /><rect x="2" y="6" width="14" height="12" rx="2" /></Icon>
